"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var model_actions_creators_1 = require("./../../../../../store/model.actions.creators");
var styles = __importStar(require("./../../SchoolPerformance.module.css"));
function mapStateToProps(_a) {
    var model = _a.model;
    return { json_data: model.json_data };
}
var mapDispatchToProps = {
    updateJsonCallback: model_actions_creators_1.updateJson
};
var COLLEGE = {
    CA: {
        city: "Sacramento",
        address: "1215 Howe Ave Suite 101",
        zip: "95825",
        phone: "(916) 649-9600",
        fax: "(916) 649-9700"
    },
    NV: {
        city: "Las Vegas",
        address: "6029 W. Charleston Blvd.",
        zip: "89146",
        phone: "702-836-9900",
        fax: "702-836-3583"
    },
    TX: {
        city: "Dallas",
        address: "9330 Lyndon B. Johnson Freeway Suite 650",
        zip: "75243",
        phone: "972-248-9000",
        fax: "972-248-0125"
    }
};
function SchoolPerformanceHeader(props) {
    var state = props.json_data["campusState"] || "CA";
    var college = COLLEGE[state];
    return (react_1.default.createElement("div", { className: "row" },
        react_1.default.createElement("div", { className: "col-xs-6 col-md-6" },
            react_1.default.createElement("img", { className: styles.imgWidth, src: "/img/logo-asher.jpg", alt: "" })),
        react_1.default.createElement("div", { className: "col-xs-6 col-md-6 " + styles.textRight },
            react_1.default.createElement("p", null,
                react_1.default.createElement("b", null, "Asher College - " + college.city,
                    react_1.default.createElement("br", null),
                    college.address,
                    react_1.default.createElement("br", null), college.city + ", " + state + " " + college.zip,
                    react_1.default.createElement("br", null), "Phone: " + college.phone,
                    react_1.default.createElement("br", null), "Fax: " + college.fax)),
            react_1.default.createElement("a", { href: "http://www.asher.edu" }, "http://www.asher.edu"))));
}
exports.SchoolPerformanceHeader = SchoolPerformanceHeader;
exports.AsherSchoolPerformanceHeader = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SchoolPerformanceHeader);
//# sourceMappingURL=data:application/json;base64,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